export default {
  setUser: (state, payload) => { state.user = payload },
  setPopup: (state, payload) => { state.showPhonePopup = payload },
  setShowedPopup: (state, payload) => { state.showedPopup = payload },
}